

































import { Component, Vue } from 'vue-property-decorator';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';

@Component({
    name: 'c-req-docs-modal'
})
export default class CBudgetReqDocsErrorModal extends Vue {
    private showModal = false;
    private data: any[] = [];

    private showEvent(reqDocsLst: any[]) {
        if (!reqDocsLst.length) { return; }
        this.data = reqDocsLst;
        this.showModal = true;
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get allTitle() {
        const obj = {
            title: this.getBudgetText('sum_calc_gu.req_doc_modal.title'), // Отправка на Согласование невозможна, т.к. не прикреплены документы в формах
            gu: this.getBudgetText('sum_calc_gu.gu'), // ГУ
            prg: this.getBudgetText('sum_calc_abp.prg'), // Программа
            ppr: this.getBudgetText('sum_calc_abp.ppr'), // Подпрограмма
            forms: this.getBudgetText('sum_calc_gu.req_doc_modal.forms'), // Формы
        }
        return obj;
    }
}
